import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, generatePath } from 'react-router-dom'
import { APKEditableForm } from 'app/views/APKEditView/APKEditableForm'
import { RootState } from 'app/state/types'
import { onInputChange, onSelectChange } from 'app/utils/hooks'
import { updateNewApk, setIsLoading } from 'app/state/appSlice'
import { createAppApk } from 'app/services/client'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { isTokenExpired } from 'app/utils/hooks'
import {
    makeTokenHeaderConfig,
    useTokenHeaderConfig,
} from 'app/services/tokenConfig'
import { handleServerAPIError } from 'app/services/utils'

const AddAPKView = () => {
    const { newApk } = useSelector((state: RootState) => state.appSlice)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { appid } = useParams()
    const [token] = useTokenHeaderConfig()

    const onApkChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) =>
            onInputChange(e)(dispatch, updateNewApk),
        [updateNewApk, onInputChange, dispatch],
    )

    const onApkSelectChange = useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) =>
            onSelectChange(e)(dispatch, updateNewApk),
        [updateNewApk, onSelectChange, dispatch],
    )

    const onApkArcChange = useCallback(
        (fieldName: string, value: number) => {
            dispatch(
                updateNewApk({
                    [fieldName]: value === 1,
                }),
            )
        },
        [dispatch, updateNewApk],
    )

    const onFormSubmit = useCallback(() => {
        dispatch(setIsLoading(true))
        if (appid) {
            createAppApk(appid, newApk, makeTokenHeaderConfig(token))
                .then(() => {
                    navigate(
                        generatePath(APP_ROUTES.APP_DETAILS, { id: appid }),
                    )
                })
                .catch(e => handleServerAPIError(e, dispatch, navigate))
                .finally(() => dispatch(setIsLoading(false)))
        }
    }, [
        dispatch,
        navigate,
        generatePath,
        appid,
        newApk,
        createAppApk,
        setIsLoading,
        handleServerAPIError,
    ])

    useEffect(() => {
        if (isTokenExpired()) navigate(APP_ROUTES.LOGIN)
    }, [])

    return (
        <APKEditableForm
            apk={newApk}
            onApkChange={onApkChange}
            onApkSelectChange={onApkSelectChange}
            onSubmit={onFormSubmit}
            onApkArcChange={onApkArcChange}
        />
    )
}

export default AddAPKView
